import { FormControl, ValidationErrors } from '@angular/forms';
import { UliOrigin } from '../../../../../../common/constants';
import { CarrierModel } from '../../../../../../common/models';

export function carrierUliOriginValidator(origin: UliOrigin): (control: FormControl<CarrierModel>) => ValidationErrors {
  if (!origin) {
    return null;
  }
  return (control: FormControl<CarrierModel>) =>
    !control.value && (origin === UliOrigin.GateApp || origin === UliOrigin.WebApp) ? { required: true } : null;
}
